import React from "react";
import { SummaryCard, SummaryContainer, SummaryParent } from "./summary.styles";




const Summary = () => {

    return (
        <SummaryParent>
           
                     
                      
                <SummaryContainer>
                    <SummaryCard background="#ffffff" borderColor="#ffffff">
                        
                    </SummaryCard>
                    <SummaryCard background="#ffffff" borderColor="#ffffff">
                        
                    </SummaryCard>
                    <SummaryCard background="ffffff" borderColor="ffffff">
                        
                    </SummaryCard>
                </SummaryContainer>
            
        </SummaryParent>



    )




}


export default Summary;

